import { SVGProps } from 'react';

const LibraryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.667 2.5v3.333a.833.833 0 0 0 .833.834h3.333"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 17.5H5.833a1.667 1.667 0 0 1-1.666-1.667V4.167A1.667 1.667 0 0 1 5.833 2.5h5.834l4.166 4.167v2.916M7.5 7.5h.833M7.5 10.833h5M7.5 14.167H10M15.833 18.75a3.958 3.958 0 0 1 2.917-2.917 3.958 3.958 0 0 1-2.917-2.916 3.959 3.959 0 0 1-2.916 2.916 3.96 3.96 0 0 1 2.916 2.917Z"
    />
  </svg>
);

export default LibraryIcon;
